import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { settingsService } from 'src/services/settings.service'
import { useUser } from '../auth'
import { EUserRoles } from 'src/types'

export const useCheckMaticLowBalance = () => {
  const { data: user } = useUser()

  return useQuery(
    QUERY_KEYS.SETTINGS_CHECK_MATIC_LOW_BALANCE,
    () => settingsService.checkMatickBalance(),
    {
      keepPreviousData: true,
      enabled: !!user && user.roles.includes(EUserRoles.superadmin),
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )
}
